import { media } from '@displate/styleguide';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

export const FooterInfoBoxWrapper = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colorsV2.grayscale.gray10};
  border-radius: 4px;

  .payment-images {
    margin: 16px 17% 0 17%;

    img {
      height: 26px;
      margin: 0;

      ${media.medium} {
        height: 40px;
      }
    }
  }

  ${media.medium} {
    flex: 1;
    border-radius: 8px;
  }
`;

export const FooterInfoBoxText = styled.div`
  text-align: center;
  margin: 4px 48px 0 48px;
  font-size: ${({ theme }) => theme.fontSizesV2.titleBody14.lg};
  font-weight: 300;
  line-height: 20px;

  ${media.medium} {
    margin-top: 4px;
  }
`;

export const FooterInfoBoxHeader = styled.h3`
  text-align: center;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizesV2.title20.lg};
  top: 24px;
  line-height: 20px;

  ${media.medium} {
    font-size: ${({ theme }) => theme.fontSizesV2.title24.lg};
    line-height: 36px;
  }
`;

export const FooterInfoBoxSingleIcon = styled(LazyLoadImage)`
  display: block;
  margin: 16px auto auto auto;
  height: 50px;

  ${media.medium} {
    height: 58px;
  }
`;
export const FooterInfoBoxMultipleIconWrapper = styled.div`
  margin: 0 17% 0 17%;
  padding-top: 16px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  img {
    height: 26px;
    ${media.medium} {
      height: 40px;
    }
  }
`;
